import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const RecipientEmail = styled.span`
  color: ${props => props.theme.colors.text.muted};
`
